<template>
  <div class="upcoming-reactive-rover">
    <h2>Upcoming Classes</h2>
    <div v-if="dates.length">
      <div class="upcoming-classes-container" v-for="date in dates" :key="date.days">
        <div class="upcoming-class">
          <div>{{date.days}}</div>
          <div>Starting: {{date.starting}}</div>
          <div>Ending: {{date.ending}}</div>
          <div>Location: {{date.location}}</div>
          <div>{{date.price}}</div>
          <div>Limited to {{date.limit}} spots</div>
          <div v-if="date.notes" class="notes">{{date.notes}}</div>
        </div>
        <va-button @click="openModal(date)" class="request-button">Request to join class</va-button>
      </div>
    </div>
    <div v-else>
      More dates coming soon!
    </div>
    <va-modal v-model="showModal" title="Request to Join Reactive Rover Class" :message="modalMessage"
      position="top" size="large" hide-default-actions>
      <group-class-form :groupClass="requestedGroupClass" @sent-request="closeModal" />
      <div class="cancel-button" style="display: flex; justify-content: center;">
        <va-button flat color="gray" @click="closeModal">
          Cancel
        </va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import GroupClassForm from '../forms/GroupClassForm'

export default {
  name: 'reactive-rover-card',
  components: {
    GroupClassForm,
  },
  data () {
    return {
      dates: [
        // {
        //   days: 'Thursdays at 6:00pm MDT',
        //   starting: 'June 10, 2021',
        //   ending: 'July 15, 2021',
        //   location: 'Virtual',
        //   price: '$160',
        //   limit: 6,
        //   type: 'Reactive Rover',
        //   notes: 'Reactive dogs learn best where they can actually think - at home!',
        // },
      ],
      showModal: false,
      modalMessage: 'Request to join class',
      requestedGroupClass: {},
    }
  },
  methods: {
    openModal (groupClass) {
      this.modalMessage = `Request to join ${groupClass.days} ${groupClass.type} class`
      this.requestedGroupClass = groupClass
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
  },
}
</script>

<style scoped lang="scss">
.upcoming-reactive-rover {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;

  .upcoming-classes-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .upcoming-class {
      display: flex;
      flex-direction: column;
      border-left: 2px solid $gray;
      margin: 0.5rem;
      padding-left: 0.5rem;

      .notes {
        font-style: italic;
      }
    }

    .request-button {
      height: 3rem;
      width: auto;
    }
  }
}
</style>
